import eventData from "../localData/eventData.json";

const events = (state = eventData, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default events;
